<template>
  <div class="page-container bg-white">
    <div class="pageHead-wrapper">
      <PageHeader title="商品管理">
        <template slot="icon">
          <img :src="pageIcon" width="16px" height="16px" alt="">
        </template>
      </PageHeader>
    </div>
    <!-- 查询表单 -->
    <div class="search-panel">
      <Json2Form
        :form="form"
        :fieldsSource="fieldsSource"
        :options="options"
        :btns="btns"
        formClass="json2form"
        @submit="handleSubmit"
        @cancel="resetForm"
        ref="search-form"
      >
        <template slot="score" slot-scope="form, item">
          <IntervalNumber v-model="form[item.name]" />
        </template>
        <template slot="total_stock" slot-scope="form, item">
          <IntervalNumber v-model="form[item.name]" />
        </template>
        <template slot="line_code" slot-scope="form, item">
          <a-tree-select
            tree-default-expand-all
            v-model="form[item.name]"
            :tree-data="treeData"
            :maxTagCount="2"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :replaceFields="{
              children: 'sub_line',
              title: 'name',
              key: 'code',
              value: 'code',
            }"
          />
        </template>
      </Json2Form>
    </div>
    <!-- 列表 -->
    <div class="content">
      <a-button
        type="primary"
        class="greenBtn"
        icon="plus"
        @click="handleJump('create', record)"
      >
        新增商品
      </a-button>
      <Table
        :columns="columns"
        :data-source="tableData"
        :scroll="{ x: 1400 }"
        :pagination="ipagination"
        @change="handleTableChange"
        rowKey="uuid"
        :loading="tableLoading"
      >
        <template slot="status" slot-scope="text, record">
          <State :text="record.status_name" :status="record.status_className" />
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              type="link"
              v-text="record.status === 'offline' ? '上架' : '下架'"
              @click="handleShowOnline(record)"
            />
            <a-button type="link" @click="handleJump('edit', record)">
              编辑
            </a-button>
            <a-button
              type="link"
              :disabled="record.status === 'online'"
              @click="handleShowDel(record)"
            >
              删除
            </a-button>
            <a-button
              type="link"
              @click="handleShowDetail(record)"
            >
              库存明细
            </a-button>
          </a-space>
        </template>
      </Table>
    </div>
    <!-- 弹出框 -->
    <!-- 删除 -->
    <Confirm
      :visible="deleteVisible"
      :maskClosable="false"
      okText="删除"
      @cancel="cancelDeleteDialog"
      @ok="confirmDeleteDialog"
    >
      确认删除该商品？
    </Confirm>
    <!-- 上/下架 -->
    <Confirm
      :visible="onlineVisible"
      okText="确认"
      @cancel="cancelOnlineDialog"
      @ok="confirmOnlineDialog"
      prefixCls="confirm-modal"
      :maskClosable="false"
    >
      是否{{ operateName }}当前商品？
    </Confirm>
    <!-- 库存明细 -->
    <a-modal
      v-model="modelVisible"
      :title="modelTitle"
      :destroyOnClose="true"
      ok-text="关闭"
      cancel-text=""
      @ok="modelVisible = false"
      :footer="null"
      :width="1000"
      :maskClosable="false"
      dialogClass="commonModal"
    >
      <StockDetail :uid="record.uuid" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Json2Form from '@/components/Json2Form';
import PageHeader from '@/components/PageHeader/customPageHeader';
import IntervalNumber from '@/components/intervalNumber/intervalNumber';
import { Table, Confirm } from '@/components/';
import State from '@/components/State/status.vue';
import StockDetail from './components/stockDetail.vue';

import { STATE_EUNM, GOODLIST_COLUMS, FIELD_SOURCE } from './constants/';
import { getGoodsList, goodsEdit, goodsDel } from '@/api/goods';
import { goodsTypeEunm, goodsKindEunm } from '@/constants/goods';
import { paginationItem } from '@/constants/goods/';

export default {
  name: 'TableList',
  components: {
    Json2Form,
    Table,
    State,
    Confirm,
    PageHeader,
    IntervalNumber,
    StockDetail,
  },
  data() {
    return {
      form: {},
      searchFormData: {},
      pageIcon: require('@/assets/img/icon-fill-incentive.png'),
      tableLoading: false,
      deleteVisible: false, // 删除确认框
      onlineVisible: false, // 上/下架确认框
      modelVisible: false, // 库存明细弹框
      modelTitle: '库存明细', // 库存明细弹框标题
      record: {}, // 当前选中记录
      fieldsSource: FIELD_SOURCE, // 表单查询
      columns: GOODLIST_COLUMS, // 表格列
      operateName: '',
      tableData: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        ...paginationItem,
      },
      btns: [
        {
          action: 'submit',
          text: '查询',
          style: {
            color: '#fff',
            background: '#345FEC',
            border: 'none',
          },
        },
        {
          action: 'reset',
          text: '重置',
          force: true,
        },
      ],
      options: {
        layout: 'inline',
        gutter: 12,
        labelCol: {
          xl: {
            span: 8,
          },
          xxl: {
            span: 6,
          },
        },
        wrapperCol: {
          xl: {
            span: 16,
          },
          xxl: {
            span: 18,
          },
        },
      },
    };
  },
  created() {},
  mounted() {
    // 获取表格数据
    this.handleSubmit();
  },
  methods: {
    // 点击删除
    handleShowDel(record) {
      this.record = record;
      this.deleteVisible = true;
    },
    // 取消删除
    cancelDeleteDialog() {
      this.deleteVisible = false;
    },
    // 确认删除
    confirmDeleteDialog() {
      goodsDel({
        uuid: this.record.uuid,
      }).then((res) => {
        console.log(res);
        this.deleteVisible = false;
        this.getTableData();
      });
    },
    // 点击上架
    handleShowOnline(record) {
      this.record = record;
      this.operateName = STATE_EUNM[record.status].operateName;
      this.onlineVisible = true;
    },
    // 取消上架
    cancelOnlineDialog() {
      this.onlineVisible = false;
    },
    // 确认上/下架
    confirmOnlineDialog() {
      const status = this.record.status === 'online' ? 'offline' : 'online';
      // 调用更新接口
      this.onlineVisible = false;
      this.tableLoading = true;
      goodsEdit({
        status,
        uuid: this.record.uuid,
      }).then((res) => {
        console.log(res);
        this.ipagination.current = 1;
        this.getTableData();
      });
    },
    // 重置表单
    resetForm() {
      this.form = {};
    },
    // 点击库存明细
    handleShowDetail(record) {
      this.record = record;
      this.modelTitle = `库存明细-${record.name}`;
      this.modelVisible = true;
    },
    // 页面跳转
    handleJump(type, record) {
      const { query } = this.$route;
      if (type === 'edit') {
        this.$router.push({
          path: `/mall/goods/${type}`,
          query: {
            ...query,
            uuid: record.uuid,
          },
        });
      } else {
        this.$router.push({
          path: `/mall/goods/${type}`,
          query: {
            ...query,
          },
        });
      }
    },
    // 查询
    handleSubmit() {
      const formData = this.$refs['search-form'].getFieldsValue();
      // 时间
      if (formData.action_time && formData.action_time.length > 0) {
        formData.update_start_time = moment(formData.action_time[0]).valueOf();
        formData.update_end_time = moment(formData.action_time[1]).valueOf();
      } else {
        formData.update_start_time = null;
        formData.update_end_time = null;
      }
      // 所需积分
      if (formData.score && formData.score.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        formData.score_start = formData.score[0];
        // eslint-disable-next-line prefer-destructuring
        formData.score_end = formData.score[1];
      }
      // 库存
      if (formData.total_stock && formData.total_stock.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        formData.total_stock_start = formData.total_stock[0];
        // eslint-disable-next-line prefer-destructuring
        formData.total_stock_end = formData.total_stock[1];
      }
      this.searchFormData = Object.assign({}, formData);
      this.ipagination.current = 1;
      this.getTableData();
    },
    // 获取商品列表
    getTableData() {
      this.tableLoading = true;
      // 接口调用
      const params = {
        ...this.searchFormData,
        current: this.ipagination.current,
        page_size: this.ipagination.pageSize,
      };
      getGoodsList(params).then((res) => {
        console.log(res);
        this.tableLoading = false;
        this.ipagination = {
          current: res.current,
          pageSize: res.page_size,
          total: res.total,
          ...paginationItem,
        };
        this.tableData = (res.items || []).map((v) => ({
          ...v,
          type_name: goodsTypeEunm[v.type],
          kind_name: goodsKindEunm[v.kind],
          update_time: moment(v.update_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
          status_name: STATE_EUNM[v.status] ? STATE_EUNM[v.status].text : '',
          status_className: STATE_EUNM[v.status] ? STATE_EUNM[v.status].className : '',
        }));
      });
    },
    // 分页改变
    handleTableChange(pagination) {
      this.ipagination.current = pagination.current;
      this.ipagination.pageSize = pagination.pageSize;
      this.getTableData();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/index.less";
.content /deep/.ant-table-thead > tr:first-child > th:last-child{
  padding-left: 31px;
}
/deep/.ant-modal-body{
  padding-top: 0;
}
</style>
